import axios from 'axios';
import { menuUrl } from '../env';
import { getAuthHeaders } from './utils';
import { QRLinkResolveResponse } from '../interfaces/qr_links';
/* eslint-disable */

export const qrLinksApi = {
  async getLinks(qrUniqueId: string) {
    return axios.get<QRLinkResolveResponse>(
      `${menuUrl}/api/v1/qr-links/resolve?unique_id=${encodeURIComponent(
        qrUniqueId,
      )}`,
      {
        headers: await getAuthHeaders(),
      },
    );
  },
  async logClick(linkId: number) {
    // Fire-and-forget analytics -- never let a failure here block guest navigation.
    try {
      return await axios.post(
        `${menuUrl}/api/v1/qr-links/${linkId}/click`,
        {},
        {
          headers: await getAuthHeaders(),
        },
      );
    } catch (e) {
      return null;
    }
  },
};
